export const Arrow = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.75 10.1251H12.1275L8.4675 13.7851C8.175 14.0776 8.175 14.5576 8.4675 14.8501C8.76 15.1426 9.2325 15.1426 9.525 14.8501L14.4675 9.90756C14.76 9.61506 14.76 9.14256 14.4675 8.85006L9.5325 3.90004C9.24 3.60754 8.7675 3.60754 8.475 3.90004C8.1825 4.19254 8.1825 4.66504 8.475 4.95754L12.1275 8.62506H3.75C3.3375 8.62506 3 8.96256 3 9.37506C3 9.78756 3.3375 10.1251 3.75 10.1251Z"
      fill="currentColor"
    />
  </svg>
);
